import csv from 'csvtojson';
import store from '@/store';

const riskMapColours = [
    { risk: 'Low', color: "#91be63" },
    { risk: 'Moderate Low', color: "#BDDBB0" },
    { risk: 'Moderate', color: "#FFE14F" },
    { risk: 'Moderate High', color: "#E7A723" },
    { risk: 'High', color: "#EF4343" },
    { risk: 'Very High', color: "#A71229"}
  ];


async function loadata(): Promise<{

    cpiData: any[],
    consumptionData: any[],
    gdpData: any[],
    importDataData: any[],
    inflationData: any[],
    investmentData: any[],
    industryPerformanceData: any[],
    riskData: any[],
    ESGGovernanceCoruptionData: any[],
    ESGGovernanceWGIGEData: any[],
    ESGGovernanceWGIPolSData: any[],
    ESGGovernanceWGIRolSData: any[],
    ESGGovernanceWGIRQData: any[],
    ESGSocialFSIUEDData: any[],
    ESGSocialHDIData: any[],
    ESGEnvironmentalRExposureData: any[],
    ESGEnvironmentalInformData : any[],
    exportData: any[]


}>{
    const csvDir = getCSVDataDir();
    
    const [
        cpiRawCSV,
        consumptionDataRawCSV,
        gdpDataRawCSV,
        importDataDataRawCSV,
        inflationDataRawCSV,
        investmentDataRawCSV,
        industryPerformanceDataRawCSV,
        riskDataRawCSV,
        ESGGovernanceCoruptionDataRawCSV,
        ESGGovernanceWGIGEDataRawCSV,
        ESGGovernanceWGIPolSDataRawCSV,
        ESGGovernanceWGIRolSDataRawCSV,
        ESGGovernanceWGIRQDataRawCSV,
        ESGSocialFSIUEDDataRawCSV,
        ESGSocialHDIDatRawCSV,
        ESGEnvironmentalRExposureDataRawCSV,
        ESGEnvironmentalInformDataRawCSV,
        exportDataRawCSV
    ] = await Promise.all([
        
        await fetch(csvDir + 'data_fiscal_balance.csv').then(response => response.text()),
        await fetch(csvDir + 'data_private_consumption.csv').then(response => response.text()),
        await fetch(csvDir + 'data_gdp.csv').then(response => response.text()),
        await fetch(csvDir + 'data_import.csv').then(response => response.text()),
        await fetch(csvDir + 'data_inflation.csv').then(response => response.text()),
        await fetch(csvDir + 'data_investment.csv').then(response => response.text()),
        await fetch(csvDir + 'data_industryPerformance.csv').then(response => response.text()),
        await fetch(csvDir + 'data_star.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Governance-Corruption.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Governance-WGI-GE.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Governance-WGI-PolS.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Governance-WGI-RoL.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Governance-WGI-RQ.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Social-FSI-UED.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Social-HDI.csv').then(response => response.text()),
        // await fetch(csvDir + 'data_ESG-Environmental-RExposure.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Environmental-Exposure.csv').then(response => response.text()),
        await fetch(csvDir + 'data_ESG-Environmental-Inform.csv').then(response => response.text()),
        await fetch(csvDir + 'data_export.csv').then(response => response.text()),
    ]);

    const [
        cpiData,
        consumptionData,
        gdpData,
        importDataData,
        inflationData,
        investmentData,
        industryPerformanceData,
        riskData,
        ESGGovernanceCoruptionData,
        ESGGovernanceWGIGEData,
        ESGGovernanceWGIPolSData,
        ESGGovernanceWGIRolSData,
        ESGGovernanceWGIRQData,
        ESGSocialFSIUEDData,
        ESGSocialHDIData,
        ESGEnvironmentalRExposureData,
        ESGEnvironmentalInformData,
        exportData
    ] = await Promise.all([
        csv().fromString(cpiRawCSV),
        csv().fromString(consumptionDataRawCSV),
        csv().fromString(gdpDataRawCSV),
        csv().fromString(importDataDataRawCSV),
        csv().fromString(inflationDataRawCSV),
        csv().fromString(investmentDataRawCSV),
        csv().fromString(industryPerformanceDataRawCSV),
        csv().fromString(riskDataRawCSV),
        csv().fromString(ESGGovernanceCoruptionDataRawCSV),
        csv().fromString(ESGGovernanceWGIGEDataRawCSV),
        csv().fromString(ESGGovernanceWGIPolSDataRawCSV),
        csv().fromString(ESGGovernanceWGIRolSDataRawCSV),
        csv().fromString(ESGGovernanceWGIRQDataRawCSV),
        csv().fromString(ESGSocialFSIUEDDataRawCSV),
        csv().fromString(ESGSocialHDIDatRawCSV),
        csv().fromString(ESGEnvironmentalRExposureDataRawCSV),
        csv().fromString(ESGEnvironmentalInformDataRawCSV),
        csv().fromString(exportDataRawCSV)
    ]);

        return {
            cpiData,
            consumptionData,
            gdpData,
            importDataData,
            inflationData,
            investmentData,
            industryPerformanceData,
            riskData,
            ESGGovernanceCoruptionData,
            ESGGovernanceWGIGEData,
            ESGGovernanceWGIPolSData,
            ESGGovernanceWGIRolSData,
            ESGGovernanceWGIRQData,
            ESGSocialFSIUEDData,
            ESGSocialHDIData,
            ESGEnvironmentalRExposureData,
            ESGEnvironmentalInformData,
            exportData
        };
}

function riskToNumeric(risk: string | number): number {
    if (typeof risk === 'number') return risk;
    
    const baseValue = parseInt(risk);
    if (isNaN(baseValue)) return 0;
    
    if (risk.endsWith('+')) return baseValue - 0.3;
    if (risk.endsWith('-')) return baseValue + 0.3;
    return baseValue;
}

function calculateRiskDifference(current: string | number, previous: string | number): number {
    const currentValue = riskToNumeric(current);
    const previousValue = riskToNumeric(previous);
    return +(currentValue - previousValue).toFixed(2);
}

// New function to get risk category
function getRiskCategory(riskValue: string | number): number {
    const numericRisk = riskToNumeric(riskValue);
    const riskCategoryMap: { [key: number]: number } = {
        10: 6, 9: 5, 8: 5, 7: 4, 6: 4, 5: 3, 4: 2, 3: 2, 2: 1, 1: 1, 0: 0
    };
    return riskCategoryMap[Math.round(numericRisk)] || 0;
}

async function convert(){
    const countryKeyDataString = await fetch( getCSVDataDir() +'/countryKeys.json');
    const countryKeys = await countryKeyDataString.json();
    const countries = [];
    const data = await loadata();

    for (const countryKey of countryKeys) {
        const { country_name, country_code, iso } = countryKey;

        if (!country_name || !country_code || !iso) {
            console.error(`Invalid country key: ${JSON.stringify(countryKey)}`);
            continue;
        }

        const cpiData = data.cpiData.filter(entry => entry.iso === iso);
        const consumptionData = data.consumptionData.filter(entry => entry.iso === iso);
        const gdpData = data.gdpData.filter(entry => entry.iso === iso);
        const importDataData = data.importDataData.filter(entry => entry.iso === iso);
        const inflationData = data.inflationData.filter(entry => entry.iso === iso);
        const investmentData = data.investmentData.filter(entry => entry.iso === iso);
        const industryPerformanceData = data.industryPerformanceData.filter(entry => entry.iso === iso);
        const riskData = data.riskData.filter(entry => entry.iso === iso);
        const exportData = data.exportData.filter(entry => entry.iso === iso);

        const esgData = {
            environmental:{
                name: "Environmental",
                description: "Environmental data",
                re:{
                    name: "Renewable Energy",
                    data:data.ESGEnvironmentalRExposureData.filter(entry => entry.ISO === iso)
                },
                inform: {
                    name: "Environmental Information",
                    data:data.ESGEnvironmentalInformData.filter(entry => entry.ISO === iso)
                },
            },
            governance:{
                name: "Governance",
                description: "Governance data",
                corruption: {
                    name: "Corruption",
                    description: "Coruption Perception Index",
                    data:data.ESGGovernanceCoruptionData.filter(entry => entry.ISO === country_code)
                },
                wgi:{
                    name: "World Governance Indicators",
                    description: "World Governance Indicators",
                    pols:{
                        name: "Political Stability",
                        description: "WGI: Political stability and absence of violence",
                        data: data.ESGGovernanceWGIPolSData.filter(entry => entry.ISO === country_code)
                    },
                    rols:{
                        name: "Rule of Law",
                        description: "WGI: Rule of Law",
                        data:data.ESGGovernanceWGIRolSData.filter(entry => entry.ISO === country_code)
                    },
                    ge:{
                        name: "Government Effectiveness",
                        description: "WGI: Government effectiveness",
                        data:data.ESGGovernanceWGIGEData.filter(entry => entry.ISO === country_code)
                    },
                   
                    rq:{
                        name: "Regulatory Quality",
                        description: "WGI: Regulatory Quality",
                        data:data.ESGGovernanceWGIRQData.filter(entry => entry.ISO === country_code)
                    }
                }
            },
            social:{
                name: "Social",
                fsi: {
                    name: "Fragile States Index",
                    description: "Fragile States Index",
                    data:data.ESGSocialFSIUEDData.filter(entry => entry.ISO === country_code)
                },
                hdi: {
                    name: "Human Development",
                    description: "Human Development",
                    data:data.ESGSocialHDIData.filter(entry => entry.ISO === country_code)
                }
            }
        };


        let riskCategory = 0;
        let riskCategoryObject = {};

        try {
            if (riskData[0] && riskData[0].star !== undefined) {
                riskCategory = getRiskCategory(riskData[0].star);

                for (let i = 0; i < riskMapColours.length; i++) {
                    if (riskCategory == i + 1) {
                        riskCategoryObject = riskMapColours[i];
                    }
                }

                // Calculate and assign the risk difference
                riskData[0].difference = calculateRiskDifference(
                    riskData[0].star,
                    riskData[0].star_previous_quarter
                );
            }
        } catch (error) {
            console.error('Error processing risk data:', error);
        }

        const newCountry = {
            country_name: country_name,
            country_object_code: country_code,
            iso: iso,
            cpi: cpiData,
            consumption: consumptionData,
            gdp: gdpData,
            importData: importDataData,
            inflation: inflationData,
            investment: investmentData,
            industryPerformance: industryPerformanceData,
            riskData: riskData,
            riskCategoryObject,
            esgData,
            exportData
        };

        countries.push(newCountry);
    }

    return countries;


}


function getCSVDataDir(){
    
    const appElement = document.getElementById('app');
    if (!appElement) {
        throw new Error('App element not found');
    }
    return appElement.getAttribute('data-countryDataDir');
}

function getStaticResourcesPath(){
    const appElement = document.getElementById('app');
    if (!appElement) {
        throw new Error('App element not found');
    }
    return appElement.getAttribute('data-staticResourcesPath');
}

export async function storeTooltipData(){
    const toolTipDataString = await fetch( getCSVDataDir() +'/tooltips.json');
    const tooltips = await toolTipDataString.json();
    store.dispatch('displayStoreData/setToolTipData', tooltips);
}

export { convert, getCSVDataDir, getStaticResourcesPath, riskToNumeric, getRiskCategory, riskMapColours };
